import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { validationRules } from './validationRules';
import InputBox from '../shared/InputBox';
import ClinicAddress from './ClinicAddress';
import SelectMenu from '../shared/SelectMenu';
import DatePicker from '../shared/DatePicker';
import { checkErrorForm } from 'src/utils/ehrValidators';
import Facility from 'src/models/facility';
import Clinic, { ClinicInformationRequest } from 'src/models/clinic';
import { ExternalData } from 'src/utils/customInterface';
import { MaskPattern, RegistrationStep, WorkflowContext } from 'src/utils/constValues';
import { parseDateToSendToServer } from 'src/utils/formater';
import { ProviderInfoPayment } from 'src/models/provider';
import { clearSessionStorage, getCurrentStepRouter, removeWorkflowContextData, retryAllowed, setAttemptCounter, workflowPermanentFail } from 'src/utils/workflow';
import Workflow from 'src/models/workflow';
import { getDuplicateClinicIds } from 'src/utils/addressUtility';
const USStates: Array<ExternalData> = require('src/api/data/states.json');

export interface StateFromProps {
    saving: boolean;
    saved: boolean;
        facilities: Array<Facility>;
    isPass: boolean;
    loadingFacilities: boolean;
    registrationId: string;
    userInfo: string;
    providerInformation: ProviderInfoPayment;

    workflow: Workflow;
    checkRetry: boolean;
}

export interface DispatchFromProps {
    getFacilitiesByTenantNameAsync: (tenantName: string) => void;
    addClinicInformation: (clinicInformation: ClinicInformationRequest) => void;
    updateWorkflow: (workflow: Workflow) => void;
}

export interface State {
    hasError: boolean;
    triggerCheckError: boolean;
    hasErrorClinics: boolean;
    npiMask: string;
    showPopup: boolean;

    clinicInformation: ClinicInformationRequest;

    showDuplicateAddressErrorMsg: boolean;
    duplicateAddressIds: Set<string>;
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

class ClinicInformation extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        window.document.title = 'Clinic';
        this.state = this.getInitialState();
    }

        componentDidMount() {
            setAttemptCounter('0', false);
        }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.saved && nextProps.isPass
            && nextProps.workflow.isCurrentStepFinished
            && nextProps.workflow.currentStep === RegistrationStep.ContractAgreement) {
            removeWorkflowContextData(WorkflowContext.USER_INFO.toString());
            this.props.history.push(getCurrentStepRouter(nextProps.workflow));
        }

        if (this.props.checkRetry !== nextProps.checkRetry && nextProps.checkRetry) {
            if (retryAllowed(false)) {

                this.setState({ showPopup: true });
            } else {
                console.log('Permanent fail');
                this.props.updateWorkflow(workflowPermanentFail());
                clearSessionStorage();
                this.props.history.push('/registration/completewithpermanentfail');
            }
        }
    }

    getInitialState(): State {
        return {
            triggerCheckError: false,
            hasErrorClinics: true,
            showDuplicateAddressErrorMsg: false,
            npiMask: '',
            showPopup: false,

            clinicInformation: this.initialClinicInformation(),
            hasError: checkErrorForm(validationRules, this.initialClinicInformation()),
            duplicateAddressIds: new Set<string>()
        };
    }
    
    initialClinicInformation = (): ClinicInformationRequest => {
        let clinicInformation: ClinicInformationRequest = {
            registrationId: '',
            userInfo: '',
            lastname: '',
            clinicName: '',
            clinics: [],
            stateLicense: '',
            issuingState: '',
            expDate: '',
            dea: '',
            deaExpDate: '',
            npi: ''
        };

        return clinicInformation;
    }

    handleChange = (value: string, field: any): void => {
        if (field === 'npi') {
            if (value && value != '' && value !== '__________') {
                this.setState({ npiMask: MaskPattern.NPI });
            }
            else {
                this.setState({ npiMask: '' });
            }
        }

        this.setState((prevState: State) => {
            const newClinicInformation: ClinicInformationRequest = {
                ...prevState.clinicInformation,
                [field]: value
            };
            return {
                ...prevState,
                clinicInformation: newClinicInformation,
                hasError: checkErrorForm(validationRules, { ...newClinicInformation, [field]: value })
            };
        });
    }

    updateClinics = (clinics: Array<Clinic>, hasError: boolean): void => {
        const { clinicInformation } = this.state;
        clinicInformation.clinics = clinics;

        // Check duplicate clinic addresses
        let isExistDup = false;
        // if (clinics && clinics.length > 1) {
        //     for (var i = 0; i < (clinics.length - 1); i++) {
        //         let compareCli = clinics[i];
        //         let compareArr = clinics.slice(i + 1);
        //         isExistDup = compareArr.some(e => e.addressLine1.trim().toLowerCase() === compareCli.addressLine1.trim().toLowerCase() &&
        //             e.city.trim().toLowerCase() === compareCli.city.trim().toLowerCase() &&
        //             e.state.trim().toLowerCase() === compareCli.state.trim().toLowerCase() &&
        //             e.zipCode.trim().toLowerCase() === compareCli.zipCode.trim().toLowerCase());
        //         if (isExistDup) {
        //             break;
        //         }
        //     }
        // }

        if (clinics && clinics.length > 1) {
            const duplicateAddressIds = getDuplicateClinicIds(clinics);
            isExistDup = duplicateAddressIds.size > 0;
            this.setState({ duplicateAddressIds: duplicateAddressIds });
        }

        this.setState({
            hasErrorClinics: hasError || isExistDup,
            clinicInformation: clinicInformation,
            showDuplicateAddressErrorMsg: isExistDup
        });
    }
    
    saveClinicInformation = (): void => {
        const { hasError, hasErrorClinics, triggerCheckError, clinicInformation } = this.state;
        const { registrationId, userInfo, providerInformation } = this.props;

        if (hasError || hasErrorClinics) {
            this.setState({ triggerCheckError: !triggerCheckError });
            return;
        }

        if (clinicInformation.clinics.length === 0) {
            alert('Please fill in the clinic address information!');
            return;
        }

        const requestInfo: ClinicInformationRequest = {
            ...clinicInformation,
            expDate: parseDateToSendToServer(clinicInformation.expDate),
            deaExpDate: parseDateToSendToServer(clinicInformation.deaExpDate),
            registrationId: registrationId ?? '',
            userInfo: userInfo ?? '',
        };

        if (providerInformation) {
            if (providerInformation.physicianLastName) {
                requestInfo.lastname = providerInformation.physicianLastName;
            } else {
                requestInfo.lastname = '';
            }
        }

        this.props.addClinicInformation(requestInfo);
    }

    render() {

        const {
            clinicInformation,
            triggerCheckError,
            showDuplicateAddressErrorMsg,
            npiMask,
            duplicateAddressIds
        } = this.state;
        const { saving, loadingFacilities, facilities } = this.props;

        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <h5 className="card-title-sp">Clinic Information</h5>
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">
                                                            <div className="autoscroll-1 border-cont">
                                                                {
                                                                    saving ?
                                                                        <div className="loading-center">
                                                                            <table className="table table-borderless">
                                                                                <tbody className="spinner-bg d-flex">
                                                                                    <tr className="text-center">
                                                                                        <td className="alert alert-info" role="alert">
                                                                                            <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />{saving ? 'Submitting...' : 'Loading...'}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        :
                                                                        <form>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label" htmlFor="txtClinicName">1. Clinic Name <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <InputBox
                                                                                        id="txtClinicName"
                                                                                        extendClass={['width350', 'width150']}
                                                                                        field="clinicName"
                                                                                        label="Clinic Name"
                                                                                        value={clinicInformation.clinicName}
                                                                                        rules={validationRules.clinicName}
                                                                                        onChange={this.handleChange}
                                                                                        onBlur={() => this.props.getFacilitiesByTenantNameAsync(clinicInformation.clinicName)}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">2. Clinic Addresses <span className="required-icon">*</span></label>
                                                                                <ClinicAddress
                                                                                    retainClinics={clinicInformation.clinics}
                                                                                    triggerCheckError={triggerCheckError}
                                                                                    updateClinics={this.updateClinics}
                                                                                    clinicName={clinicInformation.clinicName}
                                                                                    loadingFacilities={loadingFacilities}
                                                                                    facilities={facilities}
                                                                                    showDuplicateAddressMsg={showDuplicateAddressErrorMsg}
                                                                                    duplicateAddressIds={duplicateAddressIds}
                                                                                //key={resetKey}
                                                                                />
                                                                            </div>

                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label" htmlFor="txtStateLicenseNo">3. Provider State License # <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtStateLicenseNo"
                                                                                        extendClass={['', 'width125']}
                                                                                        field="stateLicense"
                                                                                        label="State License"
                                                                                        value={clinicInformation.stateLicense}
                                                                                        rules={validationRules.stateLicense}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="sbIssuingState">Issuing State <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <SelectMenu
                                                                                        id="sbIssuingState"
                                                                                        extendClass={['', 'width115']}
                                                                                        field="issuingState"
                                                                                        label="Issuing State"
                                                                                        value={clinicInformation.issuingState}
                                                                                        rules={validationRules.issuingState}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    >
                                                                                        <option value="">SELECT</option>
                                                                                        {USStates.map(state => <option key={state.code} value={state.code}>{state.name}</option>)}
                                                                                    </SelectMenu>
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="dpExpDate">Exp. Date <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <div className="input-group">
                                                                                        <DatePicker
                                                                                            id="dpExpDate"
                                                                                            extendClass="width125"
                                                                                            field="expDate"
                                                                                            label="Exp. Date"
                                                                                            value={clinicInformation.expDate}
                                                                                            rules={validationRules.expDate}
                                                                                            onChange={this.handleChange}
                                                                                            triggerCheckError={triggerCheckError}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <small className="license-helper-text">Less than 25 characters and License format: e.g., Z1234567 or 1234567
                                                                            </small>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label" htmlFor="txtDEANo">4. Provider DEA # <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtDEANo"
                                                                                        // extendClass={triggerCheckDEA && !deaLoading && !deaIsValid ? ['width125 display-inline-block has-error', 'width125'] : ['width125 display-inline-block', 'width125']}
                                                                                        extendClass={['width125 display-inline-block', 'width125']}
                                                                                        field="dea"
                                                                                        label="Provider DEA #"
                                                                                        value={clinicInformation.dea}
                                                                                        rules={validationRules.dea}
                                                                                        onChange={this.handleChange}
                                                                                        // onBlur={this.onBlurDEA}
                                                                                        // errorMessage={triggerCheckDEA && !deaLoading && !deaIsValid ? 'This DEA already exists' : ''}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                    {/* {
                                                                                        deaLoading && <span className="spinner-border text-info custom-loading-inline" role="status" aria-hidden="true" />
                                                                                    }
                                                                                    {
                                                                                        triggerCheckDEA && !deaLoading && !deaIsValid &&
                                                                                        <span className="error-text">Error: This DEA already exists in the system. Please login to your account or contact support.</span>
                                                                                    } */}
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="dpDEAExpDate" style={{ marginLeft: '18px' }}>Exp. Date <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <div className="input-group">
                                                                                        <DatePicker
                                                                                            id="dpDEAExpDate"
                                                                                            extendClass="width125"
                                                                                            field="deaExpDate"
                                                                                            label="DEA Exp. Date"
                                                                                            value={clinicInformation.deaExpDate}
                                                                                            rules={validationRules.deaExpDate}
                                                                                            onChange={this.handleChange}
                                                                                            triggerCheckError={triggerCheckError}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label" htmlFor="txtNPI">5. Provider NPI <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtNPI"
                                                                                        // extendClass={triggerCheckNPI && !npiLoading && !npiIsValid ? ['width125 display-inline-block has-error', 'width125'] : ['width125 display-inline-block', 'width125']}
                                                                                        extendClass={['width125 display-inline-block', 'width125']}
                                                                                        field="npi"
                                                                                        label="Provider NPI"
                                                                                        value={clinicInformation.npi}
                                                                                        rules={validationRules.npi}
                                                                                        mask={npiMask}
                                                                                        onChange={this.handleChange}
                                                                                        // onBlur={this.onBlurNPI}
                                                                                        // errorMessage={triggerCheckNPI && !npiLoading && !npiIsValid ? 'This NPI already exists' : ''}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                    {/* {
                                                                                        npiLoading && <span className="spinner-border text-info custom-loading-inline" role="status" aria-hidden="true" />
                                                                                    }
                                                                                    {
                                                                                        triggerCheckNPI && !npiLoading && !npiIsValid &&
                                                                                        <span className="error-text">Error: This NPI already exists in the system. Please login to your account or contact support.</span>
                                                                                    } */}
                                                                                </div>
                                                                            </div>
                                                                            {/* <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">16. Provider Tax ID <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <InputBox
                                                                                        id="txtTaxID"
                                                                                        extendClass={['width125', 'width125']}
                                                                                        field="taxId"
                                                                                        label="Provider Tax ID"
                                                                                        value={provider.taxId}
                                                                                        rules={validationRules.taxId}
                                                                                        mask="999999999"
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                    />
                                                                                </div>
                                                                            </div> */}
                                                                        </form>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-btn-group d-flex align-items-center">
                                    <button className="btn btn-sm btn-light" type="submit" onClick={this.saveClinicInformation} disabled={false}><i className="fa fa-arrow-right" /> Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default ClinicInformation;


// WEBPACK FOOTER //
// ./src/components/ClinicInformation/ClinicInformation.tsx